import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import PurchaseNotifications from './PurchaseNotifications';
import SalesNotifications from './SalesNotifications';

const Notifications = (props) => {
    const { t } = useTranslation("translations");
    const companyId = props.match.params.id
    const [activeTab, setActiveTab] = useState('purchase')

    return (
        <div className="mb-4">
            <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                    <a
                        className={`nav-link ${activeTab === 'purchase' ? 'active text-primary' : 'text-dark'} `}
                        onClick={() => setActiveTab('purchase')}
                        role="tab"
                        style={{ cursor: 'pointer' }}
                    >
                        {t("company.purchaseNotifications")}
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={`nav-link ${activeTab === 'sales' ? 'active  text-primary' : 'text-dark'} `}
                        onClick={() => setActiveTab('sales')}
                        role="tab"
                        style={{ cursor: 'pointer' }}
                    >
                        {t("company.salesNotifications")}
                    </a>
                </li>
            </ul>

            <div className="tab-content pt-3">
                <div className={`tab-pane fade ${activeTab === 'purchase' ? 'show active' : ''}`} role="tabpanel">
                    {activeTab === 'purchase' && <PurchaseNotifications companyId={companyId} />}
                </div>
                <div className={`tab-pane fade ${activeTab === 'sales' ? 'show active' : ''}`} role="tabpanel">
                    {activeTab === 'sales' && <SalesNotifications companyId={companyId} />}
                </div>
            </div>
        </div>
    )
}

export default withRouter(Notifications)